import { render, staticRenderFns } from "./ReportWidgetResources.vue?vue&type=template&id=65a9cbe1"
import script from "./ReportWidgetResources.vue?vue&type=script&lang=js"
export * from "./ReportWidgetResources.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports